import React, {FC} from "react";
import { useTranslation } from 'react-i18next';
import TypeOfUseTag from "./type-of-use-tag";

type TypeOfUseTagProps = {
  text?: string;
  className?: string;
};

const IndustrialTypeTag: FC<TypeOfUseTagProps> = ({className}) => {
  const { t } = useTranslation();
  return (
    <TypeOfUseTag className={className} type="industrial" text={t('type-of-use-tag.industrial')} width={114} />
  );
};

const ResidentialTypeTag: FC<TypeOfUseTagProps> = ({className}) => {
  const { t } = useTranslation();
  return (
    <TypeOfUseTag className={className} type="residential" text={t('type-of-use-tag.residential')} width={126} />
  );
};

const ServiceTypeTag: FC<TypeOfUseTagProps> = ({className}) => {
  const { t } = useTranslation();
  return (
    <TypeOfUseTag className={className} type="service" text={t('type-of-use-tag.service')} width={99}/>
  );
};

const CommercialTypeTag: FC<TypeOfUseTagProps> = ({className}) => {
  const { t } = useTranslation();
  return (
    <TypeOfUseTag className={className} type="commercial" text={t('type-of-use-tag.commercial')} width={130}/>
  );
};

const GovernmentalTypeTag: FC<TypeOfUseTagProps> = ({className}) => {
  const { t } = useTranslation();
  return (
    <TypeOfUseTag className={className} type="governmental" text={t('type-of-use-tag.governmental')} width={146} />
  );
};

const OtherTypeTag: FC<TypeOfUseTagProps> = ({text, className}) => {
  const { t } = useTranslation();
  return (
    <TypeOfUseTag className={className} type="other" text={text || t('type-of-use-tag.other')} />
  );
};


export {
  IndustrialTypeTag,
  ResidentialTypeTag,
  ServiceTypeTag,
  CommercialTypeTag,
  GovernmentalTypeTag,
  OtherTypeTag,
};
